module.exports = __webpack_public_path__ + "static/media/workshopicon.a4e479b5.svg";